import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { SupplierDto } from '@api/models/suppliers/SupplierDto';
import { EntityState } from '@api/models/enums/EntityState';
import { supplierService } from '@api/services/services';

export interface SupplierListFilter extends ListFilter {
  state?: EntityState;
  canLendEmployees?: boolean;
}

export type SupplierListState = ListType<SupplierDto, SupplierListFilter>;

const initialState: SupplierListState = {
  state: FetchState.None,
  data: undefined,
  query: {
    state: EntityState.Active,
    sortBy: 'name',
    sortDesc: false,
  },
};

export const supplierListSlice = listSlice({
  name: 'supplierList',
  initialState,
});

export const selectSupplierList = (state: RootState) => state.supplierList;
export const supplierListActions = supplierListSlice.actions;

export const getSupplierList = (cancelToken: CancelToken) => (dispatch: AppDispatch) => {
  const storeState = store.getState();
  const data = selectSupplierList(storeState);

  const handleGetData = (size: number) => {
    return supplierService.query(
      {
        q: data.query.q,
        state: data.query.state,
        page: data.query.page,
        size: size,
        sort: getListSort(data),
        canLendEmployees: data.query.canLendEmployees,
      },
      { cancelToken: cancelToken as any },
    );
  };

  getList({
    dispatch,
    cancelToken,
    state: data.state,
    actions: supplierListActions,
    getData: handleGetData,
  });
};
